export enum CustomerLicenseDisplayOption {
  DoNotShowLicenseCount = 0,
  ShowLicenseCount = 1,
}